module.exports = __webpack_public_path__ + "static/media/ICONO-CARPETA-PREMIUM.70d46278.png";